import * as React from 'react'
import { ModalBody } from 'react-bootstrap'
import { BaseModalProps } from '@modals/types'
import { IconWithText } from '@components/icon-with-text'
import { LocalForClientWithBenefitAvailable } from '@modules/accommodation-selection-step/local-selection/local-selection-map/local-for-client-with-benefit/local-for-client-with-benefit-available'
import { LocalForClientWithBenefitNotAvailable } from '@modules/accommodation-selection-step/local-selection/local-selection-map/local-for-client-with-benefit/local-for-client-with-benefit-not-available'
import { Apartment, Promocode } from '@models/reservation'
import { useAppSelector } from '@store/index'
import { selectReservation } from '@store/selectors/reservation-selectors'

interface Props extends BaseModalProps {
  apartment?: Apartment
  onSubmit?: (promocode: Promocode | null) => Promise<void>
}

export const LocalForClientWithBenefitModal = ({ apartment, onSubmit, toggleIsVisible }: Props): JSX.Element => {
  const [isLoading, setIsLoading] = React.useState(false)
  const { promocode } = useAppSelector(selectReservation)

  const handleSubmit = async () => {
    try {
      if (!apartment) return
      setIsLoading(true)
      await onSubmit?.(promocode)

      toggleIsVisible()
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <ModalBody className="text-muted ps-lg-5 pe-xl-0 px-4 px-lg-0 overflow-hidden d-flex">
      <div className="col-lg-5 col-12 pt-4 me-5 pb-4 d-flex flex-column justify-content-between">
        <div>
          <h2 className="text-purple text-center text-xl-start">Lokale specjalne</h2>
          <hr className="d-block d-xl-none mx-n5" />
          {apartment?.benefit_is_available ? (
            <LocalForClientWithBenefitAvailable />
          ) : (
            <LocalForClientWithBenefitNotAvailable />
          )}
        </div>
        <div className="d-flex justify-content-between gap-1">
          <button
            className="btn-unstyled mt-4 ms-auto ms-lg-0 subscription-with-benefits-owner-modal__close-button"
            onClick={toggleIsVisible}
          >
            <IconWithText text="Zamykam" iconClassName="uil-times me-2 font-size-xl lh-0" textClassName="fw-bold" />
          </button>
          {apartment?.benefit_is_available && (
            <button
              disabled={isLoading}
              className="btn-unstyled mt-4 ms-auto ms-lg-0 subscription-with-benefits-owner-modal__close-button"
              onClick={handleSubmit}
            >
              <IconWithText
                wrapperClassName="align-items-center"
                isLoading={isLoading}
                loadingText="Wybieranie..."
                text="Wybieram i idę dalej"
                iconClassName="uil-check me-2 font-size-xl lh-0"
                textClassName="fw-bold"
              />
            </button>
          )}
        </div>
      </div>
      <div className="position-relative w-100 d-none d-lg-block">
        <button className="subscription-with-benefits-owner-modal__close-button-icon" onClick={toggleIsVisible}>
          <i className="uil-times" />
        </button>
        <img
          className="subscription-with-benefits-owner-modal__image"
          height="100%"
          width="100%"
          alt="Lokale specjalne Holiday Park & Resort"
          loading="lazy"
          src={require('@assets/images/local-for-benefits-owner-modal.webp')}
        />
      </div>
    </ModalBody>
  )
}
